module.exports = __webpack_public_path__ + "stylesheets/wave-my-projects_49b77414787954388c83755d7dac0abb.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-my-projects.less
// module id = hQA3
// module chunks = 51